import { clsx } from "clsx";

import styles from "./JoinLabel.module.scss";

type JoinLabelType = "conditions" | "events" | "properties";

export function JoinLabel({ text, type = "properties" }: { text: string; type: JoinLabelType }): JSX.Element {
    return <div className={clsx(styles.joinLabel, styles[type])}>{text}</div>;
}
